import { render } from "./FahrzeugFach.vue?vue&type=template&id=5137ce1d"
import script from "./FahrzeugFach.vue?vue&type=script&lang=js"
export * from "./FahrzeugFach.vue?vue&type=script&lang=js"

import "./FahrzeugFach.vue?vue&type=style&index=0&id=5137ce1d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__